const defaultForm = () => ({
	name: '',
	product_id: '',
	date: '',
	date_end: '',
	attributes: {
		saleStageDigitalFolder: '',
		saleStatusDigitalFolder: '',
		saleStage: '',
		saleStatus: '',
		via_cliente: false,
		via_caixa: false,
		reserveOnlyToCalledCustom: false,
		password: '',
		tableValues: [],
		contract_selected: null,
		typesOfPayments: []
	}
})

const defaultMenuList = () => [
	{
		id: 1,
		name: 'Dados Principais',
		tag: 'main-data',
		link: 'launch.management.create.mainData',
		completed: false,
		seted: true,
		editing: true,
		title: 'Criar novo Lançamento Imobiliário'
	},
	{
		id: 2,
		name: 'Pontos de Atendimento',
		tag: 'services-points',
		link: 'launch.management.create.servicePoints',
		completed: false,
		seted: false,
		editing: false,
		title: 'Criar novo Lançamento Imobiliário'
	},
	{
		id: 3,
		name: 'Operadores de Caixa',
		tag: 'operators-box',
		link: 'launch.management.create.boxOperators',	
		completed: false,
		seted: false,
		editing: false,
		title: 'teste3'
	},
	{
		id: 4,
		name: 'Fomas de Pagamento',
		tag: 'payment-methods',
		link: 'launch.management.create.paymentMethods',	
		completed: false,
		seted: false,
		editing: false,
		title: 'teste4'
	},
	{
		id: 5,
		name: 'Planos de Pagamento',
		tag: 'payment-plans',
		link: 'launch.management.create.paymentPlans',
		completed: false,
		seted: false,
		editing: false,
		title: 'teste5'
	},
	{
		id: 6,
		name: 'Comissionamento',
		tag: 'commissioning',
		link: 'launch.management.create.commissioning',
		completed: false,
		seted: false,
		editing: false,
		title: 'teste6'
	},
]
const buttonsMenu = () => [
	{
		id: 1,
		name: 'Dados Principais',
		link: 'launch.management.create.mainData',
		completed: true,
	},
	{
		id: 2,
		name: 'Pontos de Atendimento',
		link: 'launch.management.create.servicePoints',
		completed: false,
	},
	{
		id: 3,
		name: 'Operadores de Caixa',
		link: 'launch.management.create.boxOperators',	
		completed: false,
	},
	{
		id: 4,
		name: 'Fomas de Pagamento',
		link: 'launch.management.create.paymentMethods',	
		completed: false,
	},
	{
		id: 5,
		name: 'Planos de Pagamento',
		link: 'launch.management.create.paymentPlans',
		completed: false,
	},
	{
		id: 6,
		name: 'Comissionamento',
		link: 'launch.management.create.commissioning',
		completed: false,
	},
]

export {
	defaultForm,
	defaultMenuList,
	buttonsMenu
}